import Script from "next/script";

export default function Ad_728x90_Bot() {
  return (
    <div className="ad-728X90-bottom">
      <div className="Leaderboard">
        {/* Load Google AdSense Script */}
        <Script
          async
          src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-2622226100196993"
          crossorigin="anonymous"
          strategy="afterInteractive"
        />

        {/* PCG-Bot-728x90 Ad */}
        <ins
          className="adsbygoogle"
          style={{ display: "inline-block", width: "728px", height: "90px" }}
          data-ad-client="ca-pub-2622226100196993"
          data-ad-slot="6064669728"
        ></ins>

        {/* Initialize AdSense */}
        <Script id="adsbygoogle-init" strategy="afterInteractive">
          {`(adsbygoogle = window.adsbygoogle || []).push({});`}
        </Script>
      </div>
    </div>
  );
}
